<template>
    <main>
        <!-- Modal -->
        <modalNotasList :notas="notas" :usuario="usuario" :idUsuario="idUsuario" ref="listNotas" v-on:ultima-nota="cargarUltimaNota(idUsuario)"></modalNotasList>  
        <!-- Modal -->
        <modalNotasCreate :notas="notas" :usuario="usuario" :idUsuario="idUsuario" ref="createNotas" v-on:ultima-nota="cargarUltimaNota(idUsuario)"></modalNotasCreate>  
        <div class="card-header bg-light border-bottom-0">
            <div class="row align-items-center w-100">
          <div class="col-6 font-weight-bold text-gray-600 h6 mb-0">
            <i class="fas fa-user-nurse mr-2"></i> Notas Enfermería 
          </div>
          <div class="col-6 d-flex justify-content-end">
            <button class="btn btn-primary btn-xs btn-icon" type="button" @click="newNota();" v-if="_can('nota.enfermeria')">
                <i class="fas fa-plus"></i>
            </button>           
          </div>
        </div>
        </div>
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="text-muted small font-weight-bold">Última Nota</span>
                    <span v-if="Object.keys(ultima_nota).length" class="text-bold font-weight-bold">{{ultima_nota.fecha}}</span>
                    <span v-else class="badge badge-light text-danger font-italic small">Sin datos...</span>
                </div>
            <button @click="historialNotas();" type="button" class="btn btn-light btn-sm btn-block text-primary font-weight-bold mt-2">Ver Notas <i class="far fa-eye fa-fw"></i></button>                
        </div>
    </main>
</template>
<script>

import notasEnfermeriaService from '../../../../services/notasEnfermeriaService';
import $ from 'jquery';
import modalNotasList from "./modalNotasList";
import modalNotasCreate from "./modalNotasCreate";
export default {
    props: ['idUsuario', 'usuario'],
    components:{modalNotasList,modalNotasCreate},
    data(){
        return {
            notas:{},
            ultima_nota:{},
            id_usuario: '',
            
        }
    },
    methods: { 
        async cargarUltimaNota(id){
            const response = await notasEnfermeriaService.showByLast(id);
            this.ultima_nota= response.data;
        },
        async historialNotas(){
            $('#modalNotasList').modal('show');
            this.$refs.listNotas.getNotas();
        },
        async newNota(){
            this.$refs.createNotas.open();
        },
    },
    watch:{
        idUsuario(){
            this.cargarUltimaNota(this.idUsuario);
        }
    },
    async created() {
        //this.cargarUltimaNota(this.idUsuario);
        await this.cargarUltimaNota(this.idUsuario);
       
    }
}
</script>